import React from 'react';
import { Card, Row, Col, Statistic, Table, Spin, Empty } from 'antd';
import { ShopOutlined, TeamOutlined, BookOutlined, DollarOutlined } from '@ant-design/icons';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const formatCurrencyBRL = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(toNumber(value));
};

const VisaoUnidadesResumoV2 = ({ data, loading, totalMatriculas }) => {
  if (loading) {
    return (
      <Card title="Visao por Unidade" style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
          <Spin size="large" tip="Carregando resumo de unidades..." />
        </div>
      </Card>
    );
  }

  if (!data || !data.kpis) {
    return (
      <Card title="Visao por Unidade" style={{ marginBottom: '24px' }}>
        <Empty description="Sem dados de unidades para o periodo selecionado" />
      </Card>
    );
  }

  const rankingData = (data.ranking_unidades || []).slice(0, 5);

  const columns = [
    {
      title: 'Unidade',
      dataIndex: 'nome',
      key: 'nome',
      ellipsis: true,
    },
    {
      title: 'Alunos',
      dataIndex: 'alunos',
      key: 'alunos',
      width: 100,
      render: (value) => toNumber(value),
    },
    {
      title: 'Turmas',
      dataIndex: 'turmas',
      key: 'turmas',
      width: 100,
      render: (value) => toNumber(value),
    },
    {
      title: 'Receita Total',
      dataIndex: 'receita_total',
      key: 'receita_total',
      width: 170,
      render: (value) => formatCurrencyBRL(value),
    },
    {
      title: 'Receita Pendente',
      dataIndex: 'receita_pendente',
      key: 'receita_pendente',
      width: 170,
      render: (value) => formatCurrencyBRL(value),
    },
  ];

  return (
    <div style={{ marginBottom: '24px' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total de Unidades"
              value={toNumber(data.kpis.total_unidades)}
              prefix={<ShopOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total de Alunos"
              value={toNumber(data.kpis.total_alunos)}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total de Matrículas"
              value={toNumber(totalMatriculas)}
              valueStyle={{ color: '#1d39c4' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total de Turmas"
              value={toNumber(data.kpis.total_turmas)}
              prefix={<BookOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Receita Total"
              value={toNumber(data.kpis.receita_total)}
              prefix={<DollarOutlined />}
              formatter={(value) => formatCurrencyBRL(value)}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Card title="Ranking de Unidades (Top 5)">
        <Table
          rowKey={(record, index) => record.id || `${record.nome}-${index}`}
          columns={columns}
          dataSource={rankingData}
          pagination={false}
          size="small"
          locale={{ emptyText: 'Sem dados para o periodo selecionado' }}
        />
      </Card>
    </div>
  );
};

export default VisaoUnidadesResumoV2;
